/* ============================================================================
   is-riepilogo.js — il riepilogo a tendina di cosa c'e' nel carrello

   Stava dentro snippets/is-riepilogo.liquid, che si rende su ogni pagina del sito
   (vedi il commento in is-cart-blocchi): ~11 KB di JavaScript nell'HTML di ogni
   pagina, mai messi in cache. Qui si scarica una volta e resta.
   Le note di merito sono rimaste in testa allo snippet.
   ========================================================================= */
(function(){
  if (window.__isRiepilogo) return;
  window.__isRiepilogo = true;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SVG_CESTINO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v6M14 11v6"/></svg>';

  function esc(s){
    return String(s || '').replace(/[&<>"']/g, function(m){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m];
    });
  }
  // i prezzi qui possono avere i centesimi (PAIO10 su 25 € fa 22,50): non si arrotonda
  function euro(c, valuta){
    var decimali = (c % 100 === 0) ? 0 : 2;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'it', {
        style:'currency', currency: valuta || 'EUR',
        minimumFractionDigits: decimali, maximumFractionDigits: decimali
      }).format(c / 100);
    } catch(e){
      return (c / 100).toFixed(decimali).replace('.', ',') + ' €';
    }
  }

  // ---- l'ordine a blocchi ---------------------------------------------------------------
  // Il carrello NON dice a quali calze appartiene un cofanetto: sono righe indipendenti.
  // Il legame si ricostruisce dalla stessa tabella che usa is-packaging per metterli dentro,
  // pubblicata nel suo <script class="is-pack__dati">: per ogni variante si sa la famiglia
  // (barattoli, stirato, extrafine) e la misura (per un paio o per due).
  function datiPackaging(){
    var el = document.querySelector('.is-pack__dati');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch(e){ return null; }
  }
  function tabellaConfezioni(dati){
    var conf = {};
    function segna(id, fam, misura){
      if (!id) return;
      var k = String(id);
      conf[k] = conf[k] || [];
      conf[k].push({ fam: fam, misura: misura });
    }
    var inc = (dati && dati.inclusi) || {};
    // sullo stirato l'incluso è uno per ogni paio; sull'extrafine copre due paia uguali
    segna(inc.doppio, 'stirato', 'singolo');
    segna(inc.doppio, 'extrafine', 'doppio');
    segna(inc.singolo, 'extrafine', 'singolo');
    ((dati && dati.tipologie) || []).forEach(function(t){
      Object.keys(t.per || {}).forEach(function(fam){
        ['singolo','doppio'].forEach(function(m){
          var c = t.per[fam] && t.per[fam][m];
          if (c) segna(c.id, fam, m);
        });
      });
    });
    return conf;
  }
  function raggruppa(items, R){
    var dati = datiPackaging();
    var mappa = (dati && dati.mappa) || {};
    var conf = tabellaConfezioni(dati);
    var senzaTabella = !Object.keys(conf).length;
    var blocchi = [], indice = {}, confezioni = [];

    // un blocco = stesse iniziali, stessa famiglia. È l'unità che riceve una confezione sua.
    items.forEach(function(item){
      if (R.eAccessorio(item)) { confezioni.push(item); return; }
      var ini = R.inizialiDi(item);
      var fam = R.famigliaDi(item, mappa);
      var k = fam + '|' + (ini ? ini.chiave : '-');
      if (!indice[k]) {
        indice[k] = { fam: fam, calze: [], confezioni: [], paia: 0 };
        blocchi.push(indice[k]);
      }
      indice[k].calze.push(item);
      indice[k].paia += item.quantity;
    });

    var coda = [];
    confezioni.forEach(function(item){
      var info = conf[String(item.variant_id)];
      var cand = blocchi;
      if (info) {
        cand = blocchi.filter(function(b){
          return info.some(function(x){ return x.fam === b.fam; });
        });
        // la confezione da due paia sta col blocco che ha due paia uguali
        if (cand.length > 1 && info.some(function(x){ return x.misura === 'doppio'; })) {
          var doppi = cand.filter(function(b){ return b.paia >= 2; });
          if (doppi.length) cand = doppi;
        }
      }
      // Se il blocco non è uno solo si va in fondo, in due casi:
      // • manca la tabella (is-packaging non in pagina): meglio non indovinare;
      // • la riga vale piu' pezzi e coprirebbe blocchi diversi — spezzarla non si puo',
      //   il cestino li toglierebbe tutti insieme.
      if (!cand.length) { coda.push(item); return; }
      if (cand.length > 1 && (senzaTabella || item.quantity > 1)) { coda.push(item); return; }
      var scelto = cand.reduce(function(a, b){
        return b.confezioni.length < a.confezioni.length ? b : a;
      });
      scelto.confezioni.push(item);
    });

    var righe = [];
    blocchi.forEach(function(b){
      b.calze.concat(b.confezioni).forEach(function(item, i){
        righe.push({ item: item, segue: i > 0 });
      });
    });
    coda.forEach(function(item){ righe.push({ item: item, segue: false }); });
    return righe;
  }

  class Riepilogo extends HTMLElement {
    connectedCallback(){
      this.precarico = !!this.closest('.is-precarico');
      this.nelPannello = !!this.closest('cart-drawer-component');
      this.chiave = 'isRiepAperto:' + (this.nelPannello ? 'pannello' : 'pagina');
      this.init();
      Riepilogo.instances.push(this);
      this.osserva();
      this.aggiorna();
    }
    disconnectedCallback(){
      if (this.mo) { this.mo.disconnect(); this.mo = null; }
      var i = Riepilogo.instances.indexOf(this);
      if (i > -1) Riepilogo.instances.splice(i, 1);
    }
    init(){
      var tst = this.querySelector('.is-riep__testi');
      var testi = window.__IS_TESTI;
      if (tst) { try { testi = JSON.parse(tst.textContent); window.__IS_TESTI = testi; } catch(e){} }
      this.t = (testi || {}).riepilogo || {};
      this.det = this.querySelector('.is-riep__det');
      this.label = this.querySelector('[data-riep-label]');
      this.corpo = this.querySelector('[data-riep-corpo]');
      if (!this.det || !this.corpo || !this.label) return false;
      var self = this;
      this.det.addEventListener('toggle', function(){
        try { sessionStorage.setItem(self.chiave, self.det.open ? '1' : '0'); } catch(e){}
      });
      return true;
    }
    osserva(){
      var self = this;
      if (this.mo) return;
      this.mo = new MutationObserver(function(){
        if (!self.corpo || !self.contains(self.corpo)) {
          if (self.init()) self.aggiorna();
        }
      });
      this.mo.observe(this, { childList: true, subtree: true });
    }
    // in pagina aperto, nel pannello chiuso. Se il cliente ha già scelto, comanda lui.
    aperturaIniziale(){
      var v = null;
      try { v = sessionStorage.getItem(this.chiave); } catch(e){}
      if (v === '1') return true;
      if (v === '0') return false;
      return !this.nelPannello;
    }
    aggiorna(){
      var self = this;
      fetch(ROOT + 'cart.js', { headers:{Accept:'application/json'}, credentials:'same-origin' })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(c){ if (c) self.render(c); })
        .catch(function(){});
    }
    rimuovi(key, bottone){
      var R = window.ISRegolePackaging;
      if (!R) return;
      if (bottone) bottone.disabled = true;
      R.scrivi('cart/change.js', { id: key, quantity: 0 })
        .then(function(risp){ if (!R.applica(risp)) window.location.reload(); })
        .catch(function(){ if (bottone) bottone.disabled = false; });
    }
    // I titoli sono lunghi e in 5 lingue: "Calze Uomo Cotone Stretch | Blu Iniziali Ricamate
    // Rosse | Taglia 40/45 | Lunghezza Ginocchio". Si tengono i primi due pezzi — modello e
    // colore — che sono quelli che distinguono un paio dall'altro; taglia e lunghezza il
    // cliente le ha appena scelte. Il taglio sulle barrette vale in tutte le lingue; il
    // prefisso "Calze Uomo/Donna/Unisex" si toglie solo dove c'è, cioè in italiano.
    nomeBreve(t, accessorio){
      var n = String(t || '').split('|').slice(0, 2).join('|')
        .replace(/^Calze\s+(Uomo|Donna|Unisex)\s*/i, '');
      // "COFANETTO IN LEGNO (per 1 paio)" → "COFANETTO IN LEGNO": la parentesi serve al
      // magazzino, non al cliente. Sulle calze non si tocca: lì dentro c'è il modello.
      if (accessorio) n = n.replace(/\s*\([^()]*\)\s*$/, '');
      return n.replace(/\s*\|\s*$/, '').trim();
    }
    /* Il prezzo di listino della riga, in centesimi, o 0 se non c'e'.
       PERCHE' DAL DOM: il Cofanetto per 2 paia costa 6 EUR e ne vale 9. Su Shopify e'
       `compare_at_price`, ma cart.js NON lo espone: fra i dodici campi di prezzo
       dell'articolo non compare. Il tema pero' lo stampa gia' nella tabella del carrello,
       che qui sta in pagina ma nascosta, e la rigenera a ogni modifica (ISRegolePackaging
       .applica sostituisce cart-items-component). Lo leggiamo da li' con `data-compare-at`,
       aggiunto in snippets/cart-products.liquid. E' il prezzo UNITARIO: va per la quantita'. */
    listinoDi(item){
      if (!item || !item.key) return 0;
      var chiave = (window.CSS && CSS.escape) ? CSS.escape(item.key) : item.key;
      var riga;
      try { riga = document.querySelector('[data-key="' + chiave + '"][data-compare-at]'); }
      catch (e) { return 0; }
      if (!riga) return 0;
      var unita = parseInt(riga.getAttribute('data-compare-at'), 10);
      if (!unita || isNaN(unita)) return 0;
      return unita * (item.quantity || 1);
    }
    render(cart){
      if (!this.corpo || !this.contains(this.corpo)) { if (!this.init()) return; }
      var self = this, R = window.ISRegolePackaging;
      var items = (cart && cart.items) || [];
      if (!R || !items.length) {
        this.hidden = true;
        if (!this.precarico) document.body.classList.remove('is-riep-attivo');
        return;
      }

      this.label.textContent = String(this.t.titolo || 'Nel carrello (%n%)')
        .replace('%n%', cart.item_count);
      this.det.open = this.aperturaIniziale();

      this.corpo.innerHTML = '';
      raggruppa(items, R).forEach(function(voce){
        var item = voce.item;
        var accessorio = R.eAccessorio(item);
        var incluso = accessorio && item.final_line_price === 0;
        var ini = accessorio ? null : R.inizialiDi(item);
        var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '';

        var dettaglio = '';
        if (ini) dettaglio += '<span class="is-riep__ini">' + esc(ini.etichetta || (ini.sx + '-' + ini.dx)) + '</span> · ';
        if (item.quantity > 1) dettaglio += '×' + item.quantity + ' · ';
        if (incluso) {
          dettaglio += '<span class="is-riep__incluso">' + esc(self.t.incluso || 'incluso') + '</span>';
        } else {
          dettaglio += esc(euro(item.final_line_price, cart.currency));
          if (item.original_line_price > item.final_line_price) {
            // c'e' uno sconto: il barrato e' il prezzo pieno della riga
            dettaglio += '<s>' + esc(euro(item.original_line_price, cart.currency)) + '</s>';
          } else {
            // nessuno sconto, ma il prodotto puo' avere un prezzo di listino piu' alto
            // (il Cofanetto per 2 paia: 6 EUR, ne vale 9). Vedi listinoDi().
            var listino = self.listinoDi(item);
            if (listino > item.final_line_price) {
              dettaglio += '<s>' + esc(euro(listino, cart.currency)) + '</s>';
            }
          }
        }

        var riga = document.createElement('div');
        riga.className = 'is-riep__riga' + (voce.segue ? ' is-riep__riga--segue' : '');
        riga.innerHTML =
          (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" decoding="async">' : '') +
          '<span class="is-riep__testo">' +
            '<b>' + esc(self.nomeBreve(item.product_title || item.title, accessorio)) + '</b>' +
            dettaglio +
          '</span>';

        if (incluso) {
          var spazio = document.createElement('span');
          spazio.className = 'is-riep__vuoto';
          riga.appendChild(spazio);
        } else {
          var cest = document.createElement('button');
          cest.type = 'button';
          cest.className = 'is-riep__cestino';
          cest.setAttribute('aria-label',
            (self.t.rimuovi || 'Rimuovi') + ' ' + (item.product_title || item.title || ''));
          cest.innerHTML = SVG_CESTINO;
          cest.addEventListener('click', function(){ self.rimuovi(item.key, cest); });
          riga.appendChild(cest);
        }
        self.corpo.appendChild(riga);
      });

      this.hidden = false;
      if (!this.precarico) document.body.classList.add('is-riep-attivo');
    }
  }
  Riepilogo.instances = [];
  if (!customElements.get('is-riepilogo')) customElements.define('is-riepilogo', Riepilogo);

  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var t = null;
  function soon(){
    clearTimeout(t);
    t = setTimeout(function(){ Riepilogo.instances.forEach(function(x){ x.aggiorna(); }); }, 200);
  }
  var _f = window.fetch;
  if (_f) window.fetch = function(input){
    var u = typeof input === 'string' ? input : (input && input.url) || '';
    var pr = _f.apply(this, arguments);
    if (CART_WRITE.test(u)) pr.then(soon).catch(function(){});
    return pr;
  };
  ['cart:updated','cart:refresh','cart:change','cart:update','cart-drawer:open'].forEach(function(e){ document.addEventListener(e, soon); });
  document.addEventListener('shopify:section:load', soon);
  document.addEventListener('visibilitychange', function(){ if (!document.hidden) soon(); });
  window.addEventListener('pageshow', soon);
})();
